import { render, staticRenderFns } from "./HistoryInvite.vue?vue&type=template&id=f61abe06&"
import script from "./HistoryInvite.vue?vue&type=script&lang=js&"
export * from "./HistoryInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports